// The roles that write, mirroring trex/auth/roles.py. The API is the authority; this only decides
// whether a control is offered, and a control the API would refuse is not offered.

// OPERATIONS keeps the record straight (ADR-0007). USER is read-only and ADMIN administers the
// roster, so neither writes.
export const WRITER_ROLES = ['OPERATIONS'];

// A deal is created and edited by the departments whose papers it holds (ADR-0012): not USER, the
// baseline everyone has, and not ADMIN, which deletes a deal and otherwise leaves it alone.
export const DEAL_EDITOR_ROLES = ['OPERATIONS', 'COMMERCIAL', 'COMPLIANCE', 'RISK', 'FINANCE'];

// The people who source a counterparty add it and edit its record (ADR-0014).
export const COUNTERPARTY_EDITOR_ROLES = ['COMMERCIAL', 'OPERATIONS', 'COMPLIANCE'];

// Those who add a counterparty and those who pass its gates attach and delete its documents
// (TX-US-0033, ADR-0014).
export const COUNTERPARTY_DOCUMENT_ROLES = ['COMMERCIAL', 'OPERATIONS', 'COMPLIANCE', 'RISK', 'LEGAL'];

// The same five comment on it (TX-US-0037, ADR-0014).
export const COUNTERPARTY_COMMENT_ROLES = ['COMMERCIAL', 'OPERATIONS', 'COMPLIANCE', 'RISK', 'LEGAL'];

// The people who trade with a counterparty record its quotes and rate it (ADR-0013).
export const COUNTERPARTY_QUOTE_ROLES = ['COMMERCIAL', 'OPERATIONS'];
export const COUNTERPARTY_RATING_ROLES = ['COMMERCIAL', 'OPERATIONS'];

export const ADMIN_ROLE = 'ADMIN';

export const holdsAny = (me, roles) => Boolean(me?.roles?.some((role) => roles.includes(role)));
